import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import TableHeader from '../../atoms/table/TableHeader';
import TableHeaderCell from '../../atoms/table/TableHeaderCell';
import { useTranslation } from 'react-i18next';
const StyledTableHeaderCell = styled(TableHeaderCell) `
    min-width: 30px;
    flex: 0;
`;
const FileTableHeader = () => {
    const { t } = useTranslation();
    return (_jsxs(TableHeader, { children: [_jsx(TableHeaderCell, { children: t('file.label') }), _jsx(TableHeaderCell, { children: t('file.date') }), _jsx(StyledTableHeaderCell, {}), _jsx(StyledTableHeaderCell, {})] }));
};
export default FileTableHeader;
